export const testIsNonEmpty = <V>(value: V) => {
  const validations = [];
  if (typeof value === 'string') {
    validations.push(value.trim().length !== 0);
  }

  return [...validations, value !== null, value !== undefined].every(Boolean);
};
